
import store from "../store";
import * as types from "./constants";
import * as utils from "../utils";

export function hydratePhotoPosts() {
  const url = urls.get('ajax_event_photos', {
    event_id: window.evite_event.id,
    per_page: 120,
    gid: window.guest_id
  });
  window.$.get(url, (response) => {
    window.photoCursor = response.cursor;
    store.dispatch({
      type: types.HYDRATE_PHOTO_POSTS,
      objects: response.objects,
      cursor: response.cursor,
      more: response.more
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}

export function getPhotoPosts(cursor=window.photoCursor || '') {
  const url = urls.get('ajax_event_photos', {
    event_id: window.evite_event.id,
    per_page: 120,
    cursor: cursor,
    gid: window.guest_id
  });
  window.$.get(url, (response) => {
    window.photoCursor = response.cursor;
    store.dispatch({
      type: types.ADD_PHOTO_POSTS,
      objects: response.objects,
      cursor: response.cursor,
      more: response.more
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}

export function getPhotoPostsById(postIds) {
  const url = `/ajax/event/${window.evite_event.id}/posts/?gid=${window.guest_id}&post_ids=${postIds}`;
  window.$.get(url, (response) => {
    store.dispatch({
      type: types.ADD_MULTI_PHOTO_POSTS,
      objects: response.objects.reverse()
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/photos/actions.es6